import React, { useRef, useState, useMemo, useEffect } from "react";
import {
  AppBar,
  IconButton,
  Box,
  Typography,
  Avatar,
  Popover,
  Slide,
} from "@mui/material";
import { useRecoilValue } from "recoil";
import { atom_tourState } from "@app/shared/state/tour.atom";
import { selector } from "recoil";

// Only re-renders when header-relevant fields change, not on stops changes
const selector_headerTourInfo = selector({
  key: 'headerTourInfo',
  get: ({ get }) => {
    const tour = get(atom_tourState);
    return {
      title: tour?.title,
      config: tour?.config,
      tour_guide: tour?.tour_guide,
    };
  },
});
import { MapFilters } from "./MapFilters";
import { RateUsModal } from '../features/map/stop-details/RateUsModal';
import { useTranslation } from "react-i18next";
import { atom_dropPinMode } from '@app/shared/state/drop-pin-mode.atom';
import { useRenderTracker } from '@app/shared/debug';
// import './new-app.css';

export const MapHeader = React.memo(function MapHeader({
  setIsInfoClicked,
  showFilterNav,
  // currentWeatherZone,
  isDesktop,
  sidebarWidthPx
}: {
  setIsInfoClicked: (isInfoClicked: boolean) => void;
  showFilterNav: boolean;
  // currentWeatherZone: WeatherForecast | null;
  isDesktop: boolean;
  sidebarWidthPx: number;
}) {
  useRenderTracker('MapHeader');
  const state_TourState = useRecoilValue(selector_headerTourInfo);
  const appBarRef = useRef<HTMLDivElement>(null);
  const [showAppBar, setShowAppBar] = useState(true);
  const dropPinMode = useRecoilValue(atom_dropPinMode);
  const showAppBarBeforeDropPinRef = useRef<boolean | null>(null);

  // Hide header during drop pin positioning/naming, restore after
  useEffect(() => {
    const isDropPinActive = dropPinMode.step === 'positioning' || dropPinMode.step === 'naming';
    if (isDropPinActive && showAppBarBeforeDropPinRef.current === null) {
      // Entering drop pin mode — save current state and hide
      showAppBarBeforeDropPinRef.current = showAppBar;
      setShowAppBar(false);
    } else if (!isDropPinActive && showAppBarBeforeDropPinRef.current !== null) {
      // Exiting drop pin mode — restore previous state
      setShowAppBar(showAppBarBeforeDropPinRef.current);
      showAppBarBeforeDropPinRef.current = null;
    }
  }, [dropPinMode.step]);

  const [showRatingModal, setShowRatingModal] = useState(false);
  const [weatherAnimClass, setWeatherAnimClass] = useState('weather-pane-fade-in');
  // const [displayedZone, setDisplayedZone] = useState(currentWeatherZone);
  const { t, i18n } = useTranslation();
  const isHebrew = () => ((i18n as any).language === 'he' ? true : false);
  const [optionsPopup, setOptionsPopup] = useState(false);
  const popupRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);
  // Close popup when clicking outside or dragging
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent | TouchEvent) => {
      const target = event.target as HTMLElement;
      // Check if click is inside a MUI Menu/Popover (AccessibilityControls popup)
      const isInMuiMenu = target.closest('.MuiPopover-root, .MuiMenu-root, .MuiMenu-paper, [role="menu"]');

      if (
        optionsPopup &&
        !isInMuiMenu &&
        popupRef.current &&
        !popupRef.current.contains(target) &&
        buttonRef.current &&
        !buttonRef.current.contains(target)
      ) {
        setOptionsPopup(false);
      }
    };

    const handleDragStart = () => {
      if (optionsPopup) {
        setOptionsPopup(false);
      }
    };

    if (optionsPopup) {
      // Add a small delay to prevent immediate closure
      setTimeout(() => {
        document.addEventListener('mousedown', handleClickOutside as EventListener);
        document.addEventListener('touchstart', handleClickOutside as EventListener);
        // Listen for map drag events
        document.addEventListener('drag', handleDragStart);
        document.addEventListener('touchmove', handleDragStart);
      }, 0);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside as EventListener);
      document.removeEventListener('touchstart', handleClickOutside as EventListener);
      document.removeEventListener('drag', handleDragStart);
      document.removeEventListener('touchmove', handleDragStart);
    };
  }, [optionsPopup]);

  // useEffect(() => {
  //   if (currentWeatherZone !== displayedZone) {
  //     setWeatherAnimClass('weather-pane-fade-out');
  //     setTimeout(() => {
  //       setDisplayedZone(currentWeatherZone);
  //       setWeatherAnimClass('weather-pane-fade-in');
  //     }, 20); // match your animation duration
  //   }
  // }, [currentWeatherZone, displayedZone]);

  // const weatherDataPane = useMemo(() => {
  //   if (displayedZone) {
  //     return (
  //       <Box
  //         key={displayedZone.weather[0].locationName}
  //         className={weatherAnimClass}
  //         // name="weather-data"
  //         style={{
  //           zIndex: 9999,
  //           position: 'fixed',
  //           top: showAppBar ? 110 : 54, // <-- dynamic top value
  //           right: 5,
  //           background: 'transparent',
  //           borderRadius: 8,
  //           padding: 8,
  //           boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
  //         }}
  //       >
  //         <Box sx={{ width: 'auto', height: 'auto' }}>
  //           <Box
  //             sx={{
  //               display: 'flex',
  //               flexDirection: 'column',
  //               alignItems: 'center',
  //               gap: 1,
  //               backgroundColor: 'transparent',
  //               borderRadius: 1,
  //               width: '100%',
  //             }}
  //           >
  //             <i
  //               className={`wi ${displayedZone.weather[0].iconClass}`}
  //               style={{ fontSize: '28px', color: displayedZone.weather[0].color }}
  //             ></i>
  //             <Box
  //               sx={{
  //                 display: 'flex',
  //                 justifyContent: 'center',
  //                 alignItems: 'center',
  //                 width: '100%',
  //                 textAlign: 'center',
  //               }}
  //             >
  //               <Typography style={{ fontWeight: '580' }}>{displayedZone.weather[0].locationName}</Typography>
  //             </Box>
  //             <Box
  //               sx={{
  //                 display: 'flex',
  //                 justifyContent: 'center',
  //                 alignItems: 'center',
  //                 width: '100%',
  //                 textAlign: 'center',
  //               }}
  //             >
  //               <Typography style={{ fontWeight: '580' }}>{displayedZone.weather[0].description}</Typography>
  //             </Box>
  //             <Box
  //               sx={{
  //                 display: 'flex',
  //                 justifyContent: 'center',
  //                 alignItems: 'center',
  //               }}
  //             >
  //               <Typography style={{ fontWeight: '580' }}>{displayedZone.weather[0].temp ?? ''}°C</Typography>
  //             </Box>
  //           </Box>
  //         </Box>
  //       </Box>
  //     )
  //   }
  // }, [displayedZone, weatherAnimClass, showAppBar]);
  return (
    <>
      {!isDesktop && !(dropPinMode.step === 'positioning' || dropPinMode.step === 'naming') && (
        <IconButton
          size="small"
          edge="end"
          // aria-label="back"
          sx={{
            position: 'fixed',
            left: isHebrew() ? 16 : 'auto',
            right: isHebrew() ? 'auto' : 16,
            top: 12,
            zIndex: 11111111,
            backgroundColor: 'white !important',
            width: 35,
            height: 35,
            p: 0,
            borderRadius: '50%',
            border: '1px solid #E0E0E0',
          }}
          onClick={() => {
            setShowAppBar(showAppBar => !showAppBar);
          }}
        >
          {!showAppBar ? (
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
              <g transform="rotate(180 8.5 8)">
                <path fillRule="evenodd" clipRule="evenodd" d="M1.20453 12.1629C0.91164 11.87 0.91164 11.3951 1.20453 11.1022L7.4695 4.83727C7.7624 4.54438 8.23727 4.54438 8.53016 4.83727L14.7951 11.1022C15.088 11.3951 15.088 11.87 14.7951 12.1629C14.5022 12.4558 14.0274 12.4558 13.7345 12.1629L7.99983 6.42826L2.26519 12.1629C1.9723 12.4558 1.49743 12.4558 1.20453 12.1629Z" fill="#272525" />
              </g>
            </svg>
          ) : (
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
              <path fillRule="evenodd" clipRule="evenodd" d="M1.20453 12.1629C0.91164 11.87 0.91164 11.3951 1.20453 11.1022L7.4695 4.83727C7.7624 4.54438 8.23727 4.54438 8.53016 4.83727L14.7951 11.1022C15.088 11.3951 15.088 11.87 14.7951 12.1629C14.5022 12.4558 14.0274 12.4558 13.7345 12.1629L7.99983 6.42826L2.26519 12.1629C1.9723 12.4558 1.49743 12.4558 1.20453 12.1629Z" fill="#272525" />
            </svg>
          )}
        </IconButton>
      )}

      <Slide in={showAppBar} direction="down" timeout={400} unmountOnExit>
        <div>
          <AppBar
            dir={isHebrew() ? 'rtl' : 'ltr'}
            ref={appBarRef}
            position="sticky"
            color="default"
            elevation={1}
            sx={{
              backgroundColor: 'white',
              zIndex: 100,
              height: 60,
              width: '100%',
              display: 'flex',
              flexDirection: 'row',
              padding: '12px 16px',
              justifyContent: 'space-between',
              alignItems: 'center',
              alignSelf: 'stretch',
              borderBottom: isDesktop ? '1px solid #E0E0E0' : 'none',
            }}
          >
            <Box
              dir={isHebrew() ? 'rtl' : 'ltr'}
              sx={{
                width: 'calc(100% - 40px)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                // gap: { xs: 5, md: 10 }
              }}>
              <Box sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5
              }}>
                <Avatar
                  src={state_TourState?.tour_guide?.profile_image}
                  sx={{
                    width: 40,
                    height: 40,
                    boxShadow: `0px 0px 4px 0px ${state_TourState?.config?.['titleColor'] || '#D0552E'}`
                  }}
                  alt="Location icon"
                />
                {state_TourState?.tour_guide?.profile_image_2 ? (
                  <Avatar
                    src={state_TourState?.tour_guide?.profile_image_2}
                    sx={{
                      width: 40,
                      height: 40,
                      boxShadow: `0px 0px 4px 0px ${state_TourState?.config?.['titleColor'] || '#D0552E'}`
                    }}
                    alt={t('accessibility.tour_guide_profile') || 'Tour guide profile image'}
                  />
                ) : null}
                <Typography
                  variant="body2"
                  sx={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    textAlign: 'center',
                    color: state_TourState?.config?.tourTitleColor ? `#${state_TourState.config.tourTitleColor.replace('#', '')}` : undefined,
                  }}
                >
                  {state_TourState?.title}
                </Typography>
                {/* <p>version 13.13.13</p> */}
              </Box>
              {/* <IconButton
                ref={buttonRef}
                size="small"
                edge="end"
                aria-label="info"
                onClick={(e) => {
                  e.stopPropagation();
                  setOptionsPopup(!optionsPopup);
                }}
                sx={{
                  backgroundColor: 'white',
                  paddingLeft: isHebrew() ? '20px' : '15px',
                  paddingRight: isHebrew() ? '15px' : '20px',
                  display: 'flex',
                  justifyContent: 'center',
                  // boxShadow: '0px 0px 4px rgba(0,0,0,0.25)',
                }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="32" viewBox="0 0 8 32" fill="none">
                  <circle cx="4" cy="8" r="2" fill="black" />
                  <circle cx="4" cy="16" r="2" fill="black" />
                  <circle cx="4" cy="24" r="2" fill="black" />
                </svg>
              </IconButton> */}
              {/* {optionsPopup && <Box
                ref={popupRef}
                onClick={(e) => e.stopPropagation()}
                sx={{
                  position: 'fixed', // or 'absolute'
                  top: 60,
                  left: isHebrew() || isDesktop ? 0 : 'auto',
                  right: !isHebrew() && !isDesktop ? 0 : 'auto',
                  width: isDesktop ? `${sidebarWidthPx}px` : '100%',
                  boxShadow: '0px 8px 24px rgba(0,0,0,0.18)',
                  borderRadius: 2,
                  zIndex: 100000000, // above AppBar
                  background: 'white',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <AccessibilityControls position="top-right" />
                  <Box
                    sx={{
                      display: 'flex',
                      width: '100%',
                      height: '40px',
                      justifyContent: 'center',
                      alignItems: 'center',
                      cursor: 'pointer',
                      transition: 'background 0.2s',
                      '&:hover': {
                        backgroundColor: '#f5f5f5',
                      },
                    }}
                    onClick={() => { setResponsiveModalType('info'); setOptionsPopup(false); }}
                  >
                    <Typography
                      variant="body2"
                      sx={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        textAlign: 'center'
                      }}
                    >{t('menu_popup.info')}
                    </Typography>
                  </Box>
                </Box>
              </Box>} */}
            </Box>
          </AppBar>
        </div>
      </Slide>
      {showRatingModal && (
        <RateUsModal
          showModal={showRatingModal}
          onClose={() => setShowRatingModal(false)}
        />
      )}
      {/* MapFilters for mobile - slides up when AppBar is hidden */}
      {showFilterNav && !isDesktop && (
        <Box
          sx={{
            position: 'fixed',
            top: showAppBar ? '60px' : '12px',
            left: 0,
            right: 0,
            zIndex: 99,
            transition: 'top 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
          }}
        >
          <MapFilters showAppBar={showAppBar} sidebarWidth={sidebarWidthPx} />
        </Box>
      )}
      {/* {weatherDataPane} */}
    </>
  );
});
